export class TipoLotesVacunas {
  nombre: string;
  codigo: string;
  descripcion: string;
  imagen: string;
}
